module.exports = "/images/move-up.svg?0af2e63d6e760d8d7c4f8a656827a0cc";